import { useCallback, useEffect, useRef } from "react";

const useLatestRequest = () => {
  const latestRequestId = useRef(0);

  const beginRequest = useCallback(() => {
    latestRequestId.current += 1;
    return latestRequestId.current;
  }, []);

  const isLatestRequest = useCallback((requestId) => {
    return requestId === latestRequestId.current;
  }, []);

  useEffect(() => {
    return () => {
      latestRequestId.current += 1;
    };
  }, []);

  return { beginRequest, isLatestRequest };
};

export default useLatestRequest;
